export default "__VITE_ASSET__DHgEcvZ1__"